require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-5-tips-on-facebook-retargeting-ads.json") })
        }
      }, "path---tapd-in-5-tips-on-facebook-retargeting-ads");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-5-tips-on-facebook-retargeting-ads!./.cache/json/tapd-in-5-tips-on-facebook-retargeting-ads.json
// module id = 800
// module chunks = 231608221292675